import { render, staticRenderFns } from "./ESGstampNews.vue?vue&type=template&id=0572b905&scoped=true"
import script from "./ESGstampNews.vue?vue&type=script&lang=js"
export * from "./ESGstampNews.vue?vue&type=script&lang=js"
import style0 from "./ESGstampNews.vue?vue&type=style&index=0&id=0572b905&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0572b905",
  null
  
)

export default component.exports